import { render, staticRenderFns } from "./PostscriptPopup.vue?vue&type=template&id=4640c0e4&"
import script from "./PostscriptPopup.vue?vue&type=script&lang=js&"
export * from "./PostscriptPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports